import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import * as styles from './App.css'
import ErrorBoundary from './components/errorboundary'
import { ROUTES } from './core/actions'
import { AuthProvider } from './core/AuthContext'
import { AxiosProvider } from './core/AxiosContext'
import { isPROD, isStaging } from './core/constants'
import { GlobalProvider } from './core/GlobalContext'
import Deals from './routes/deals'
import Financier from './routes/financier'
import Login from './routes/login'
import Overview from './routes/overview'
import Deposit from './routes/overview/deposit'
import Withdraw from './routes/overview/withdraw'
import Porfolio from './routes/portfolio'
import Liquidate from './routes/portfolio/liquidate'
import Faq from './routes/financier/faq'
import Reports from './routes/financier/reports'
import Register from './routes/register'
import Root from './routes/root'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorBoundary showError={true} />,
    children: [
      { path: ROUTES.LOGIN, element: <Login /> },
      { path: ROUTES.REGISTER, element: <Register /> },
      { path: ROUTES.DEALS, element: <Deals /> },
      { path: ROUTES.OVERVIEW, element: <Overview /> },
      { path: ROUTES.DEPOSIT, element: <Deposit /> },
      { path: ROUTES.WITHDRAW, element: <Withdraw /> },
      { path: ROUTES.PORTFOLIO, element: <Porfolio /> },
      { path: ROUTES.LIQUIDATE, element: <Liquidate /> },
      { path: ROUTES.FINANCIER, element: <Financier /> },
      { path: ROUTES.FAQ, element: <Faq /> },
      { path: ROUTES.REPORTS, element: <Reports /> },
      { path: '*', element: <></> },
    ],
  },
])

// Disable console log on Production
if (isPROD || isStaging) {
  console.log = function () {}
  console.debug = function () {}
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) return false
        return failureCount < 3
      },
    },
  },
})

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className={styles.app}>
        <ErrorBoundary>
          <AuthProvider>
            <AxiosProvider>
              <GlobalProvider>
                <ConfigProvider
                  csp={{ nonce: '277ae912e6ba5f411e1ebd7a0530679b' }}
                  theme={{
                    token: {
                      colorPrimary: '#b91c1c',
                      colorLink: '#b91c1c',
                      colorLinkHover: '#9a1616',
                      colorInfo: '#b91c1c',
                      colorSuccess: '#12855f',
                      colorError: '#b91c1c',
                      colorWarning: '#c9800f',
                      borderRadius: 8,
                      fontFamily:
                        "'Montserrat', 'Open Sans', 'Roboto', sans-serif",
                    },
                    components: {
                      Button: { colorPrimary: '#b91c1c', primaryColor: '#ffffff' },
                      Tabs: { inkBarColor: '#b91c1c', itemActiveColor: '#b91c1c', itemSelectedColor: '#b91c1c' },
                    },
                  }}
                >
                  <RouterProvider fallbackElement={ErrorBoundary} router={router} />
                </ConfigProvider>
              </GlobalProvider>
            </AxiosProvider>
          </AuthProvider>
        </ErrorBoundary>
      </div>
    </QueryClientProvider>
  )
}

export default App
